module.exports = __webpack_public_path__ + "img/light_img1.84ada930.png";